import React, { useContext, useState, useEffect, useRef } from "react";
import { useDrop } from "react-dnd";
import { CanvasContext } from "../../../contexts/CanvasContext";
import Division from "./Division";
import Nav from "../RenderCompnent/Nav";
import HeaderTag from "./HeaderTag";
import Hgroup from "./Hgroup";
import Footer from "./Footer";
import Section from "./Section";
import Span from "./Span";
import DemoInstructions from "./DemoInstructions";
import "./CanvasSection.css";
import FormComponent from "./FormComponent";
import MainComponent from "./MainComponent";
import ArticleComponent from "./ArticleComponent";
import AsideComponent from "./AsideComponent";
import BRTag from "./BRTag";
import HRTag from "./HRTag";

const CanvasSection = ({ LayOut }) => {
  const {
    canvasDivisions,
    addDivision,
    addElement,
    addCanvasDrop,
    showDemoInstructions,
    showGrid,
  } = useContext(CanvasContext);

  // Calculate scaling factors based on the layout
  let scalex, scaley;

  switch (LayOut) {
    case 0:
      scalex = 0.63;
      scaley = 0.63;
      break;
    case 1:
      scalex = 0.82;
      scaley = 0.82;
      break;
    case 2:
      scalex = 0.82;
      scaley = 0.82;
      break;
    case 3:
      scalex = 0.935;
      scaley = 0.935;
      break;
    default:
      scalex = 0.82;
      scaley = 0.82;
      break;
  }

  const canvasRef = useRef(null);
  const [size, setSize] = useState({ width: "100vw", height: "100%" });

  useEffect(() => {
    if (canvasRef.current) {
      const parent = canvasRef.current.parentElement;
      const parentWidth = parent.clientWidth;
      const parentHeight = parent.clientHeight;
      setSize({ width: `${parentWidth}px`, height: `${parentHeight}px` });
    }
  }, []);

  const [, drop] = useDrop({
    accept: [
      "DroppableDiv",
      "DroppableNav",
      "DroppableHeader",
      "DroppableHGroup",
      "DroppableFooter",
      "DroppableSection",
      "DroppableSpan",
      "DroppableForm",
      "DroppableMain",
      "DroppableArticle",
      "DroppableAside",
      "DroppableLineBreak",
      "DroppableHorizontalRule",
    ],
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        if (item.type === "DroppableDiv" || item.type === "DroppableMain") {
          addDivision(null, item.name, item.type);
        } else if (
          item.type === "DroppableNav" ||
          item.type === "DroppableHeader" ||
          item.type === "DroppableHGroup" ||
          item.type === "DroppableFooter" ||
          item.type === "DroppableSection" ||
          item.type === "DroppableSpan" ||
          item.type === "DroppableForm" ||
          item.type === "DroppableArticle" ||
          item.type === "DroppableAside"
        ) {
          addCanvasDrop(null, item.name, item.type);
        } else {
          addElement(null, item.name, item.type);
        }
      }
    },
  });

  const ClassForchangeGrid = showGrid
    ? "CanvasSectionWithGrids"
    : "CanvasSection";

  return (
    <>
      <div style={{ width: size.width }}>
        {showDemoInstructions && <DemoInstructions />}
      </div>
      {!showDemoInstructions && (
        <div
          className={ClassForchangeGrid}
          ref={(node) => {
            drop(node);
            canvasRef.current = node;
          }}
          style={{
            width:
              LayOut === 0
                ? `calc(${size.width} + 4rem)`
                : `calc(${size.width} + 4rem)`,
            height:
              LayOut === 0
                ? "160%"
                : LayOut === 1 || LayOut === 2
                ? "120%"
                : "110%",
            padding: "2rem",
            overflow: "auto",
            transform: `scale(${scalex},${scaley})`,
            transformOrigin: "top left",
            boxShadow: "2px 5px 10px ",
          }}
        >
          {canvasDivisions.map((div) => {
            if (div.type === "DroppableNav") {
              return <Nav key={div.id} nav={div} />;
            } else if (div.type === "DroppableHeader") {
              return <HeaderTag key={div.id} headertag={div} />;
            } else if (div.type === "DroppableHGroup") {
              return <Hgroup key={div.id} hgroup={div} />;
            } else if (div.type === "DroppableFooter") {
              return <Footer key={div.id} footer={div} />;
            } else if (div.type === "DroppableSection") {
              return <Section key={div.id} section={div} />;
            } else if (div.type === "DroppableSpan") {
              return <Span key={div.id} span={div} />;
            } else if (div.type === "DroppableForm") {
              return <FormComponent key={div.id} form={div} />;
            } else if (div.type === "DroppableMain") {
              return <MainComponent key={div.id} main={div} />;
            } else if (div.type === "DroppableArticle") {
              return <ArticleComponent key={div.id} article={div} />;
            } else if (div.type === "DroppableAside") {
              return <AsideComponent key={div.id} aside={div} />;
            } else if (div.type === "DroppableLineBreak") {
              return <BRTag key={div.id} div={div} />;
            } else if (div.type === "DroppableHorizontalRule") {
              return <HRTag key={div.id} div={div} />;
            } else {
              return <Division key={div.id} div={div} style={div.style} />;
            }
          })}
        </div>
      )}
    </>
  );
};

export default CanvasSection;
